import { render, staticRenderFns } from "./AddTheImage.vue?vue&type=template&id=960ac3fe&lang=pug&"
import script from "./AddTheImage.vue?vue&type=script&lang=js&"
export * from "./AddTheImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports